export default __webpack_public_path__ + "static/media/ubereats-sm.a7768ba8.svg";